import React from "react"
import { StaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import classNames from "classnames"
import { media } from "utils/Media"
import WPLink from "components/shared/WPLink"
import { GatsbyImage } from "gatsby-plugin-image";
import RolexApp from "./RolexApp"
// import WeatherApp from "components/shared/WeatherApp"

const SidebarBlockWrap = styled.div`
    position: relative;
	display: block;

    a {
        text-transform: uppercase;
    }

	&.image {
	    &:before {
	        content: "";
	        position: absolute;
	        z-index: 1;
	        top: 0;
	        left: 0;
	        width: 100%;
	        height: 100%;
            background-image: linear-gradient(to right, rgba(50, 55, 65, .65), rgba(50, 55, 65, 0));
	        transition: ${props => props.theme.transitionBase};
	    }
	}
	.content1 {
	    position: absolute;
	    z-index: 3;
	    left: 17px;
	    top: 50%;
	    transform: translateY(-50%);
	    width: 90%;
	    h3 {
            font-size: 1.25rem; /*20*/
  			line-height: 1;
  			color: #fff;
  			text-transform: uppercase;
  			margin: 0 0 20px;
            font-family: ${props => props.theme.font.family.atp} !important;

            @media ${media.sm} {
                font-size: 1.5rem; /*20*/
            }
	    }
	    p {
	    	color: ${props => props.theme.colors.white};
	        text-transform: uppercase;
	        font-family: ${props => props.theme.font.family.bold};
	        /* transition: ${props => props.theme.transitionBase}; */
  			margin: 0;

            &:hover {
                color: ${props => props.theme.colors.white};
            }
	    }
	}

    &:hover {
        &:before {
            background: ${props => props.theme.colors.primary};
        }

        h3 {
            text-decoration: none;
        }
    }

    &.rolex {
		height: 199px;
	}
`

/* Used on posts and featured page, warning also used in link blocks flexible content */
const SidebarBlock = (props) => {
    const block = props.data.acfSidebarBlocks.sidebarBlockType

    return block && block.map((item, i) => {
        if (item.__typename === "WpSidebarBlock_Acfsidebarblocks_SidebarBlockType_Rolex") {
            if (props.linkBlock) {
                return <RolexApp key={i} linkBlock={props.linkBlock} />
            } else {
                return(
                    <SidebarBlockWrap
                        key={i}
                        className={classNames({
                            rolex: true,
                            "mb-2": props.margin
                        })}
                    >
                        <RolexApp key={i} linkBlock={props.linkBlock} />
                    </SidebarBlockWrap>
                )
            }
        } else {
            return item.links && item.links.map((link, i) => {
                // console.log("--------", link)
                if (link.__typename === "WpSidebarBlock_Acfsidebarblocks_SidebarBlockType_ImageLink_Links_Link") {
                    return (
                        <WPLink url={link.link.url} key={i}>
                            <SidebarBlockWrap
                                className={classNames({
                                    image: true,
                                    "mb-2": props.margin
                                })}
                            >
                                <GatsbyImage
                                    image={item.image.localFile.childImageSharp.gatsbyImageData}
                                    alt={item.image.altText} />   
                                <div className="content1">
                                    <h3 dangerouslySetInnerHTML={{ __html: props.data.title }} />
                                    <p dangerouslySetInnerHTML={{ __html: link.link.title }} />
                                </div>
                            </SidebarBlockWrap>
                        </WPLink>
                    );
                } else if (link.__typename === "WpSidebarBlock_Acfsidebarblocks_SidebarBlockType_ImageLink_Links_File") {
                    return (
                        <a 
                            href={link.file.mediaItemUrl} 
                            target="_blank"
                            rel="noopener noreferrer" 
                            key={i}
                        >
                            <SidebarBlockWrap
                                className={classNames({
                                    image: true,
                                    "mb-2": props.margin
                                })}
                            >
                                <GatsbyImage
                                    image={item.image.localFile.childImageSharp.gatsbyImageData}
                                    alt={item.image.altText} />  
                                <div className="content1">
                                    <h3 dangerouslySetInnerHTML={{ __html: props.data.title }} />
                                    <p dangerouslySetInnerHTML={{ __html: link.linkText }} />
                                </div>
                            </SidebarBlockWrap>
                        </a>
                    );
                }
                return null;
            });
        }
    });
}

SidebarBlock.defaultProps = {
    linkBlock: false
}

export default (props) => (
    <StaticQuery
        query={graphql`{
  allWpSidebarBlock(filter: {status: {eq: "publish"}}, limit: 100) {
    edges {
      node {
        databaseId
        title
        acfSidebarBlocks {
          sidebarBlockType {
            __typename
            ... on WpSidebarBlock_Acfsidebarblocks_SidebarBlockType_Rolex {
              fieldGroupName
            }
            ... on WpSidebarBlock_Acfsidebarblocks_SidebarBlockType_ImageLink {
              image {
                altText
                sourceUrl
                srcSet
                sizes
                localFile {
                  childImageSharp {
                    gatsbyImageData(width: 768, quality: 90, placeholder: NONE, layout: CONSTRAINED)
                  }
                }
              }
              links {
                __typename
                ... on WpSidebarBlock_Acfsidebarblocks_SidebarBlockType_ImageLink_Links_Link {
                  link {
                    title
                    url
                    target
                  }
                }
                ... on WpSidebarBlock_Acfsidebarblocks_SidebarBlockType_ImageLink_Links_File {
                  linkText
                  file {
                    mediaItemUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`}
        render={data => {
            return (
                // loop blocks and print if id matches
                data.allWpSidebarBlock.edges.map(({ node }, i) => {
                    if (node.databaseId === props.id) {
                        return <SidebarBlock key={i} data={node} {...props} />
                    }
                    return ""
                })
            )
        }}
    />
)